import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const OccupiedTimeIcon = (props: SvgProps) => <Svg
  width={16}
  height={16}
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M11 6.5L8 8V4.5M12 12.5C12.8284 12.5 13.5 11.8284 13.5 11C13.5 10.1716 12.8284 9.5 12 9.5C11.1716 9.5 10.5 10.1716 10.5 11C10.5 11.8284 11.1716 12.5 12 12.5ZM12 12.5C11.0375 12.5 10.2294 13.1375 10 14M12 12.5C12.9625 12.5 13.7706 13.1375 14 14M13.8095 6.5C13.6418 5.85052 13.3655 5.23026 12.9888 4.66658C12.3295 3.67989 11.3925 2.91085 10.2961 2.45673C9.19975 2.0026 7.99335 1.88378 6.82946 2.11529C5.66557 2.3468 4.59648 2.91825 3.75736 3.75736C2.91825 4.59648 2.3468 5.66557 2.11529 6.82946C1.88378 7.99335 2.0026 9.19975 2.45673 10.2961C2.91085 11.3925 3.67989 12.3295 4.66658 12.9888C5.27496 13.3953 5.94925 13.685 6.65504 13.8473'
    stroke='#3379BD'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default OccupiedTimeIcon;
